export const environment = {
  production: false,
  appInsightsConnectionString: 'InstrumentationKey=deb26ba7-5e05-4653-9b18-0c9f0037c13c;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=1d38c642-c22d-42c6-8245-ceb753484d5e',
  apiUrl: 'https://d-sentry-incident-backend.azurewebsites.net',
  blobStorageUrl: 'https://incidentlocaltesting.blob.core.windows.net',
  auth0: {
    domain: 'dev-3sy807mz.us.auth0.com',
    clientId: 'QjIdBfKQ83Mcc1o5pACQGe8n1R96hKO1',
    audience: 'https://localhost:5001',
  },
};
